import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import blogPosts from '../data/blogPosts';
import './Blog.css';

const Blog = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // SEO CollectionPage Schema
  const blogSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "headline": "FastInvoice Blog - Insights & Tips",
    "description": "Insights, tips, and news on invoicing, taxation, and business management.",
    "url": "https://fastinvoice.in/blog"
  };
  return (
    <div className="blog-page">
      <SEO 
        title="Blog"
        description="Insights, tips, and news on invoicing, taxation, and business management."
        schema={blogSchema}
      />

      <section className="blog-hero">
        <div className="bg-glow glow-top-right"></div>
        <div className="blog-hero-content">
          <Link to="/" className="blog-back-link">
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <h1>FastInvoice <span className="text-gradient">Blog</span></h1>
          <p>Insights and updates to help your business thrive.</p>
        </div>
      </section>

      <section className="blog-content">
          <div className="blog-grid">
            {blogPosts.map(post => (
              <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card" style={{ textDecoration: 'none' }}>
                <div className="blog-image">
                  <img src={post.image} alt={post.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
                </div>
                <div className="blog-card-content">
                  <div className="blog-meta">
                    <span className="blog-category">{post.category}</span>
                    <span className="blog-date">{post.date}</span>
                  </div>
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <span className="read-more">Read More <ArrowRight size={16} /></span>
                </div>
              </Link>
            ))}
          </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
